
import { Component, OnInit,ElementRef, ChangeDetectorRef, ViewChild } from '@angular/core'; 
import { LazyLoadEvent } from 'primeng/api/public_api';
import {SystemXDetailResponse} from 'src/app/models/systemx/SystemXDetail';
import{SystemxService } from 'src/app/services/systemx.service';
import { EquipmentService,TicketsService, SqacodeService,PacService,ChecklistService,ServicerequestService,FacilityService  } from 'src/app/services';
import {KeysearchComponent} from '../shared/keyLocationSearch/keysearch.component';
import {LocationcombosearchComponent} from '../shared/keyLocationSearch/locationcombosearch.component';
import { SelectItem } from 'primeng/api/selectitem';
import { Router } from '@angular/router';
import {  Pac_ComQuestionValue,UserDetail, Pac_DelayReasons, Pac,CHECKLIST_Model } from 'src/app/models';
import { __await } from 'tslib';
import { AccessUserInfo } from 'src/app/models';
import {Table} from 'primeng/table';


@Component({
  selector: 'bart-systemx-main',
  templateUrl: './systemx-main.component.html',
  styleUrls: ['./systemx-main.component.scss']
})
export class SystemxMainComponent implements OnInit {
  @ViewChild(Table,{static : false}) tableComponent: Table;
  @ViewChild(KeysearchComponent,{static:false}) keysearchComponent:KeysearchComponent;
  @ViewChild(LocationcombosearchComponent,{static:false}) locationcombosearchComponent:LocationcombosearchComponent;
  userDetail :UserDetail  =null;

  public data: any[];
  public dataSource: any[];
  public totalRecords:number=0;
  cols: any[];
  colsNew: any[];
  users:any[];
  loading = false;
  showGlobalLoader:boolean=false;
  public selectDataColumns:any[];
  public selectedData: any[];
  public selectedData1: any;
  public SelectionForDelete: any;
  IsNextButtonClicked: boolean=false;
  
  public createddate:string;

/* Variables for SelectEquipment Dropdowns*/
  public activityType: SelectItem[];
  public selectedActivity: string;

  public pacType: SelectItem[];
  public selectedPac: string;
  public response:number;
  public questionid:number;

  public checklist: SelectItem[];
  public selectedCheckList: string;

  public SQACodeList: SelectItem[];
  public selectedSQACode: string;

  public loggedinUser:string;
  public show:Boolean = false;  
  
  public Is2ComboOptionSelected = false;
  public txtReadOnly: boolean=true;
  public summaryIssueText: string;
  public selectPacChecklistService:string;
 
  public dialogDisplay: boolean = false;
  public chkRequestorValue:boolean=false;
  public IsRequestCompleted:boolean=false; 
  public IsLastBackUp:boolean=false; 
  public Comment:string="";
  public CurrentComboData:string;
  public strkeyWord123:string;
  public selectedFacility:string;
  public gridloading = false;
  public ErrorMessage :string;
  public ErrorDialoag:boolean=false;

  /* Data holding objects */
  public CommonQuestionValues1:Pac_ComQuestionValue[];
  public CommonQuestionValues3:Pac_ComQuestionValue[];
  public DelayReasons:Pac_DelayReasons[];
  public PacData:Pac[];
  public checlistData:CHECKLIST_Model[];
  public waterlogid:any;
  public responsemasterid:any;
  

  public BARTROLECODE:string = "";
  public VisiableConfirmationDialog:boolean=false;
  
  /* PAC Specific Settings */
  public DelayReasonCombo: SelectItem[];
  public DelayReasonComboSelectedValue: string;
  public DelayReasonHoursCombo: SelectItem[];
  public DelayReasonHoursComboSelectedValue: string;
  public DelayReasonMinutesCombo: SelectItem[];
  public DelayReasonMinutesComboSelectedValue: string;
  public IntendedDate: string;

  public PaCHepatitisBAntigenCombo: SelectItem[];
  public PaCHepatitisBAntigenComboSelectedValue: string;
  public PaCHepatitisBAntibodyCombo: SelectItem[];
  public PaCHepatitisBAntibodyComboSelectedValue: string;  
  public PaCFlowsheetID: string;
  public PaCHFRequired: boolean = false;
  public LastBackup:number;
  public userInfo:UserDetail;
  @ViewChild('stb', {static: false}) Searchtb: Table;
  /*Check list */
  public buildCheckList_Data:any[];
  public PopupSummaryText:string;

    GETFACILITYEQUIPMENTMANAGER = {	
      "equipmentIDList": null,
      "facilityMasterIdList": '',
      "manufacturerId":0,
      "modelId": 0,
      "serialNumber": null,
      "excludeEquipmentStatusID": null,
      "Username":"arwood",
      "SearchTerm":  "",
      "equipmentStatusId":1,
      "MachineNickName":  null,
      "MachineIPAddress": null
    }
      

  constructor( private sRequest: ServicerequestService,
    private _ChecklistService: ChecklistService, 
    private _PacService:PacService, 
    private _EquipmentService: EquipmentService, 
    private _SystemxService: SystemxService 
    ,private changeDetectorRef: ChangeDetectorRef , 
    private router:Router, 
    private _sqacodeService:SqacodeService,
    private facilityService:FacilityService,
    private elementRef:ElementRef,
    private _ticketService:TicketsService,
    ) {
      
      this.userDetail = AccessUserInfo.getUserInfo();
     }

  ngOnInit() {
    this.loggedinUser = this.userDetail.firstLastName;
    this.BARTROLECODE = this.userDetail.bartRoleCode;
    this.facilityMasterIdList = this.facilityService.getCurrentUserFacilityMasterIdList();
    this.IsNextButtonClicked = false;
    this.colsNew = [
        { field: 'EquipmentID', header: 'Equipment ID' ,hidden:false ,  display: 'table-cell'},
        { field: 'MachineNickName', header: 'Nickname',hidden:false ,  display: 'table-cell' },
        { field: 'ManufacturerName', header: 'Manufacturer',hidden:false ,  display: 'table-cell' },
        { field: 'modelNumber', header: 'Model' ,hidden:false ,  display: 'table-cell'},
        { field: 'EquipmentSerialNumber', header: 'SN/IntID' ,hidden:false,  display: 'table-cell'},
        { field: 'facilityName', header: 'Location',hidden:false ,  display: 'table-cell' },
        { field: 'EquipmentTypeDescription', header: 'Equip. Type' ,hidden:false ,   display: 'none'},
        { field: 'EquipmentSubTypeDescription', header: 'Sub Type' ,hidden:false,  display: 'table-cell'},
        { field: 'status', header: 'Status' ,hidden:false ,  display: 'none'},
        { field: 'equipmentDescription', header: 'Equipment Description',hidden:false ,  display: 'table-cell' },
        { field: 'divisionName', header: 'Division',hidden:false ,  display: 'none' },
        { field: 'regionName', header: 'Region',hidden:false ,  display: 'none' },
        { field: 'facilityNumber', header: 'Location Number',hidden:false ,  display: 'none' },
        { field: 'modalityDescription', header: 'Modality',hidden:false ,  display: 'table-cell' },
        { field: 'EquipmentTypeID', header: 'EquipmentTypeID',hidden:false ,  display: 'none' },
        { field: 'paclist', header: 'paclist',hidden:false ,  display: 'none' },
        { field: 'facilityMasterid', header: 'facilityMasterid',hidden:false ,  display: 'none' }
    ];

    this.selectDataColumns = [
      { field: 'EquipmentID', header: 'Equipment ID' ,hidden:false ,  display: 'table-cell'},
      { field: 'ManufacturerName', header: 'Manufacturer',hidden:false ,  display: 'table-cell'},
      { field: 'modelNumber', header: 'Model' ,hidden:false ,  display: 'table-cell'},
      { field: 'EquipmentSubTypeDescription', header: 'Description' ,hidden:false,  display: 'table-cell'},
      { field: 'EquipmentSerialNumber', header: 'SN/IntID' ,hidden:false,  display: 'table-cell'},
      { field: 'modalityDescription', header: 'Modality' ,hidden:false,  display: 'table-cell'},
      { field: 'divisionName', header: 'Division',hidden:false ,  display: 'table-cell'},
      { field: 'regionName', header: 'Region',hidden:false ,  display: 'table-cell' },      
      { field: 'Facility', header: 'Location',hidden:false ,  display: 'table-cell'},
      { field: 'facilityName', header: 'Location Name',hidden:false ,  display: 'none'},
      { field: 'facilityNumber', header: 'Location Number',hidden:false ,  display: 'none'},
      { field: 'EquipmentTypeDescription', header: 'Equip. Type' ,hidden:false ,  display: 'none'},      
      { field: 'status', header: 'Status' ,hidden:false ,  display: 'none'},
      { field: 'equipmentDescription', header: 'Equipment Description',hidden:false ,  display: 'none'},
      { field: 'divisionName', header: 'Division',hidden:false ,  display: 'none'},
      { field: 'regionName', header: 'Region',hidden:false ,  display: 'none'},
      { field: 'status', header: 'Status' ,hidden:false ,  display: 'none'},
      { field: 'equipmentDescription', header: 'Equipment Description',hidden:false ,  display: 'none'},
      { field: 'divisionName', header: 'Division',hidden:false ,  display: 'none' },
      { field: 'regionName', header: 'Region',hidden:false ,  display: 'none' },
      { field: 'facilityNumber', header: 'Location Number',hidden:false ,  display: 'none' },
      { field: 'modalityDescription', header: 'Modality Description',hidden:false ,  display: 'tab' },
      { field: 'EquipmentTypeID', header: 'EquipmentTypeID',hidden:false ,  display: 'none' },
      { field: 'paclist', header: 'paclist',hidden:false , display: 'none'},
      { field: 'ReferenceNo', header: 'ReferenceNo',hidden:false , display: 'none'},
      { field: 'createdate', header: 'createdate',hidden:false , display: 'none'}
  ];
  this.getDelayReasons();
  }

  /* Screen 1 events and functions starts here*/

  public btnSearchByLocation(emittedLocationId: string) {
    this.selectedData = [];
    this.IsNextButtonClicked =false;
    this.dialogDisplay = false;
    this.chkRequestorValue=false;
    this.IsRequestCompleted=false; 
    this.IsLastBackUp=false; 
     //start
     this.strkeyWord123="";
     this.Is2ComboOptionSelected = false;   
     this.selectedPac = "";   
     this.selectedCheckList = "";    
     this.selectedSQACode  = ""; 
     //end
     this.selectedData1 = null;
    
     this.CurrentComboData = emittedLocationId;
     this.GETFACILITYEQUIPMENTMANAGER.SearchTerm = "";
    
     this.data = null;
     this.tableComponent.sortOrder = 0;
     this.tableComponent.sortField = '';
     this.tableComponent.reset();
     this.keysearchComponent.strkeyWord = "";
     this.keysearchComponent.Name.reset();
     this.keysearchComponent.resetTextBox();
     this.GETFACILITYEQUIPMENTMANAGER.facilityMasterIdList = emittedLocationId;
     this.getFacilityEquipmentManager();
     if(this.Searchtb) 
     {
      this.Searchtb.reset();
     }
       
  }

  public btnSearchByKeyword(emittedKeyword: string) {
    this.selectedData = [];
    this.selectedData1 = null;    
//------start
if(emittedKeyword.length>=3)
{
this.Is2ComboOptionSelected = false;   
     this.selectedPac = "";   
     this.selectedCheckList = "";    
     this.selectedSQACode  = "";
     //-----end


    this.IsNextButtonClicked =false
    this. dialogDisplay = false;
    this. chkRequestorValue=false;
    this. IsRequestCompleted=false; 
    this. IsLastBackUp=false; 
    this.selectedFacility="";
    this.locationcombosearchComponent.selectedFacility="";
    this.GETFACILITYEQUIPMENTMANAGER.facilityMasterIdList = this.facilityMasterIdList;
    this.GETFACILITYEQUIPMENTMANAGER.SearchTerm = emittedKeyword;
    this.getFacilityEquipmentManager();
    this.Searchtb.reset();
  }
  else{
    this.ErrorMessage ='Search term must be at least three characters.';
    this.ErrorDialoag=true;	

  }

     this.data = null;
     this.tableComponent.sortOrder = 0;
     this.tableComponent.sortField = '';
     this.tableComponent.reset();
}
    
  public btnGetNext(){
    this.IsNextButtonClicked = true;
    this.activityType = [];
    this.pacType = [];
    this.checklist=[];
    this.selectedActivity = "Select Type of activity";
    this.selectedPac = "Select Pac";
    // this.GetLocationList();
    this.MasterComboData();
    this.getServiceReqSqaCodes();
    
    this.checlistData = null;

  }

  public hasPermission()
  {
    let result:Boolean=false
    if("ADMIN,BOMX,BSSX".split(",").indexOf(this.userDetail.bartRoleCode)>-1)
    {
      result= true;
      
    }
    return result
  }

 public btnConfirmation(btnaction:string){
  this.VisiableConfirmationDialog = false;
   if(btnaction=='yes')
   {
      this. data = [];
      this.dataSource=[];
      this.totalRecords=0;    
      this.loading = false;    
      this.selectedData = [];
      this.SelectionForDelete= {};
      this.IsNextButtonClicked = false;

      this. selectedActivity = "";

      this. selectedPac= "";

      this. selectedCheckList= "";

      this. selectedSQACode= "";

      this. loggedinUser= "";
    
      this. Is2ComboOptionSelected = false;
      this. txtReadOnly =true;
      this. summaryIssueText= "";
      this. selectPacChecklistService= "";
      
      this. dialogDisplay = false;
      this. chkRequestorValue=false;
      this. IsRequestCompleted=false; 
      this. IsLastBackUp=false; 
      this. Comment="";
      this. CurrentComboData= "";
      this. strkeyWord123= "";
      this. selectedFacility;
      this. gridloading = false;
      this. ErrorMessage= "";
      this. ErrorDialoag=false;

    /* Data holding objects */
    this. CommonQuestionValues1 = [];
    this. CommonQuestionValues3 = [];
    this. DelayReasons = [];
    this. PacData = [];
    this. checlistData = [];
    this. BARTROLECODE = this.userDetail.bartRoleCode;
    this. VisiableConfirmationDialog=false;
    this.router.navigate(['/ServiceRequest']);
    this.IsNextButtonClicked = false; 
    this.selectedData1 = null;
   }   
 }

  async btnCreateTicket() 
  {
     try
     {
        var valid= this.getServiceRequestsNew();
        if(valid==1 && this.selectedActivity=='1')
        {
          this.showGlobalLoader=true;
          await this.CREATESERVICEREQUEST();
          var serviceRequestId =  this.selectedData[0].ReferenceNo;   
          this.createTickt(serviceRequestId);     
        }
     }
    catch(ex)
    {
      this.showGlobalLoader=false;
    }
}

  async btnSubmitRequest(){
    


    this.IsRequestCompleted = false;
    this.show = false;
    //$("#spcreatedate").hide();
    var isSr=false;
    var success = true;
    if (this.selectedActivity=="2" && this.selectedSQACode!= "") {
      if (this.IsLastBackUp) {
        this.LastBackup = 1;
      }
      else {
      	this.LastBackup = 0;  
        isSr = true;
      }      
    }
      
    
      if (this.selectedActivity == "3") {
        var result=this.validatecl();
        if(result)
        {
      await  this.buildchecklist_alternate();
      //this.buildchecklistcopy();
      this.dialogDisplay = true;
      }
      }	
      else if (this.selectedActivity == "2") {
        success = this.validatepac();
        
        if(success)
        {
        this.builddelayreason_alternate();
        for (var nQuestionValues1 of this.selectedData) {
          this.buildpac3_alternate(nQuestionValues1);
        }
        this.dialogDisplay = true;
        }
      }
      else if (this.selectedActivity == "1") {
        this.dialogDisplay = true;
      }
      
     var status = 0;
     for(var pacid in this.selectedData)
      {
          this.selectedData[pacid].Param1Status=status;
          if(this.selectedPac=="13")
          {
            this.selectedData[pacid].Param2Status=status;
          }
          status++
       }
  }

  public btnModifySearch() {
    this.IsNextButtonClicked = false;
    this.Is2ComboOptionSelected = false;   
    this.selectedPac = "";   
    this.selectedCheckList = "";    
    this.selectedSQACode  = ""; 
}

public btnCancel(){
  this.VisiableConfirmationDialog=true;
}

btnRemoveRow(systemxdata: any) {
  this.selectedData.splice(this.selectedData.indexOf(systemxdata), 1);
  if(this.selectedData.length==0)
      this.IsNextButtonClicked = false;
      if(this.selectedData.length==1)
      {
        this.activityType.push({ label: 'Service Request', value: '1'}); 
      }  
}


public submitRequest(createticket:any) {
  var isSaved = 1; // SET TO 1 FOR POINT OF CONCEPT PURPOSES ONLY - SET BACK TO 0 WHEN PROGRAMMING THIS FUNCTION
	var isPac = false;
	var isSr = false;
	var isChecklist = false;
	var idlist = '';		
  var equipmentCount = 0;
  	
  
  // check to see if there is a list of equipment
	var reqParams = {
		facilityMasterId:'-1',
		requestDescription:'',
		serviceRequestTypeId:1,
		requestStatusId:2,
    requestSourceId:3,
    lastBackup:0,
    sqaCodeId:'',
    sqaCode:'',
    requestType:'',

	};
	var reqParams2 = {
		facilityMasterId:'Location Dropdown value',
		requestDescription:'Pac selected comments',
		serviceRequestTypeId:1,
		requestStatusId:2,
		requestSourceId:3
	};	
	var reqParams3 = {
    facilityMasterId:'Location Dropdown value',
		requestDescription:'Pac selected comments',
		serviceRequestTypeId:1,
		requestStatusId:2,
		requestSourceId:3
  };
  
  
	if (this.selectedActivity=="2" && this.selectedSQACode!= "") {
		if (this.IsLastBackUp) {
			reqParams.lastBackup = 1;
    }
    else 	reqParams.lastBackup = 0;
		reqParams.sqaCodeId = this.selectedSQACode;
		reqParams.sqaCode = this.selectedSQACode;
		reqParams.requestType = 'sr';
		isSr = true;
		
  }
  
  let checkForm = this.checkRequest(reqParams);
  if(checkForm.status==1){

    if (isSr) {
			for (var curEquipId in this.selectedData) {
        let checkPending: any
				equipmentCount++; 
				if (isSr) {
					//checkPending = checkPendingServiceRequests(reqParams);
				} else {
					checkPending = { valid:1 }; //checkPendingPacs(reqParams);
				}		
						
			}

		
    
  }
 
  if (isSaved == 1) {
		// $("#submitRequest,#modifyRequest").hide();
		// $("#serviceRequestDateSummary, #closeSummary").show();
  }
}
}

public buildEquipmentSummary() {
	let html = "";
	
	for (var curEquipId in this.selectedData) {
		//referenceId = selectedData[curEquipId].servicerequestid;
		if (this.selectedActivity== "2") {
			//referenceId = EQUIPMENT[curEquipId].pacid;
    }
    html += '<tr><td>';
    html += '<table border=1 width=100%>';
    html += '<tr><td>Equipment ID</td><td>Serial No</td><td>Type</td><td>Manufacturer</td><td>Model</td><td>Modality</td><td>Location</td><td>Reference ID</td></tr>';
         
  
		html += '<tr id="row_'+this.selectedData[curEquipId].EquipmentID+'">';
		html += "<td>" + this.selectedData[curEquipId].EquipmentID + "</td>";
		html += "<td>" + this.selectedData[curEquipId].EquipmentSerialNumber + "</td>";		
		html += "<td>" + this.selectedData[curEquipId].EquipmentSubTypeDescription + "</td>";
		html += "<td>" + this.selectedData[curEquipId].ManufacturerName + "</td>";
		html += "<td>" + this.selectedData[curEquipId].modelNumber + "</td>";
		html += "<td>" + this.selectedData[curEquipId].modalityDescription + "</td>";
		html += "<td>" + this.selectedData[curEquipId].facilityNumber + " - " + this.selectedData[curEquipId].facilityName + "</td>";
		html += "<td id='referenceId_"+ curEquipId +"'>" + this.selectedData[curEquipId].ReferenceNo + "</td>";
		html += "</tr>";
		if (this.selectedActivity == "2") {
			html += this.buildpac3([curEquipId]);	
		}
  }
  html += '</table>';
  html += '</td></tr>';
  
  
  // $('#selectedEquipmentSummary tbody').html(html);
  return html
}

////////////////////////////////////////////FORM VALIDATION 	////////////////////////////////////////////
public checkRequest(objParams) {
	var errors = new Array();
	var ret = {errorMessage:'', status:0};
	if (objParams.requestType == "sr" && objParams.sqaCode.length == 0) {
		errors.push('Activity: ');
	}
	if (objParams.requestType == "pac" && objParams.pacId.length == 0) {
		errors.push('PaC: ');
	}
	if (objParams.requestType == "checklist" && objParams.checklistid.length == 0) {
		errors.push('Checklist: ');
	}	
	
	if(errors.length) {
		var errorMsg = "The following fields cannot be blank.<br/><br/>"
		for(var i=0;i<errors.length;i++){
			errorMsg = errorMsg + errors[i] + '<br/>';
		}

		ret.errorMessage= errorMsg;		
		ret.status =  0;
  }
  else{
    ret.errorMessage= '';		
		ret.status =  1;
  }

	return ret;
}


   /* Screen 2 events and functions ends here*/




    /* Screen 3 events and functions starts here*/

   
    public popupCloseDialog(){
      
     this.selectedData = [];
     this.data=[];
    // this.gridloading=true;
    

      this.selectedFacility=null;
      this.keysearchComponent.strkeyWord="";
      
     this.strkeyWord123 = "";
     
   //((<HTMLInputElement>document.getElementById('txtKeyWord')).value)="";
  
      this.IsNextButtonClicked = false; 
      this.dialogDisplay=false; 
      this.selectedData1 = null;
      this.keysearchComponent.Name.reset();
      this.locationcombosearchComponent.selectedFacility = "";

    }
 
    public GoBack(){
      this.chkRequestorValue = false;
      this.dialogDisplay = false;
    }

    onClickradio(i:any){ 
      this.selectedData[i].Param1Status='true';
    }

    onClickradiocwp(k:any){
        this.selectedData[k].Param2Status='true';
    }

    public validatepacform(){
      var success = true;
    
    //var selresponse = $('input[name=PACID' + PAC[curpacId].PACQuestionID + '_' + curEquipId + ']:checked').val().split('*');
      for (var curEquipId in this.selectedData) {
      
        if(this.selectedData[curEquipId].Param1Status!='true')   
        {
          success=false
        }
        if(this.selectedPac=="13")
        {
         if(this.selectedData[curEquipId].Param2Status!='true')
         {
          success=false
         }
        }       
      }

      
      if (!success) {
        this.ErrorMessage ='You must select a response for each equipment';
        this.ErrorDialoag=true;	
      
      }	
      return success;
    }
  
    async btnCompleteRequest(){
      
     let items=this.selectedData;
     let pending1:any;
     var isPac = false;
     var isflag=false;
     var ischeck=true

     var isSr=false;
    if (this.selectedActivity=="2" && this.selectedSQACode!= "") {
      if (this.IsLastBackUp) {
        this.LastBackup = 1;
      }
      else
      {
      	this.LastBackup = 0;
      isSr = true;
    }
      
    }
    // this.getServiceRequestsNew();
 
     if (this.selectedActivity=="1")
     {
      isflag=true;
     }
     else if (this.selectedActivity=="2")
     {
      var pacresult=this.validatepacform();
      if(pacresult)
      {
      var result=await this.getcreatepacGroup();
        isflag=true;               
     }    
    }
    else if(this.selectedActivity=="3")
    { 
      var checklist=this.validatechecklistform();
      if(checklist)
      {
       var sucess=await this.createChecklistResponseParent();
         isflag=true;      
      }
    }
     
   if(isflag)
    { 
      var valid= this.getServiceRequestsNew();
      if(valid == 1)
     {
  
        this.CREATESERVICEREQUEST();
        this.IsRequestCompleted = true;
        this.show = this.show ? false : true;
    }
  }
         
    }
    

/* Screen 3 events and functions ends here*/

 
public onTypeofactivityChange(){
    this.IsLastBackUp=false;
   
    this.Is2ComboOptionSelected = false;  
    if (this.activityType && this.selectedActivity) {
      let item: SelectItem = this.activityType.find(s => s.value == this.selectedActivity);
      if (item)
    
        if(this.selectedActivity=="1")
        {
           this.summaryIssueText="What is the Issue: ";
           this.PopupSummaryText="Service Request Summary";
        }
      else if(this.selectedActivity=="2")
      {
        this.summaryIssueText= "PaC: ";
        this.PopupSummaryText="PaC Summary";
      }
      else if(this.selectedActivity=="3"){
        this.summaryIssueText="Checklist: ";
        this.PopupSummaryText="Checklist Summary";
      }
    } 
  }
  public onDelayReasonComboChange(eventId: string){

  }
  public onDelayReasonHoursComboChange(eventId: string){

  }
  public onDelayReasonMinutesComboChange(eventId: string){

  }
  
  public onRadioButtonChanged(data:any){
    this.summaryIssueText="What is the Issue: ";
    this.IsLastBackUp = false;
    this.Is2ComboOptionSelected = false;
    this.selectedSQACode = "";
    this.selectedActivity = '1';
    this.selectedData = [];
    this.selectedData .push(data);
    this.selectedData1 = data;
    this.getServiceReqSqaCodes();
  }

public onSQACodeListChange(eventId: string){
  
  this.selectedCheckList="";
  this.selectedPac = "";
  this.Is2ComboOptionSelected = true;
  this.PopupSummaryText="Service Request Summary";
  if (this.SQACodeList && this.SQACodeList) {
    let item: SelectItem = this.SQACodeList.find(s => s.value == this.selectedSQACode);
    //let summaryIssueText="";
    // if (item)
    // summaryIssueText = item.label;
    this.selectPacChecklistService = item.label;
  }
}
public onChecklistChange(){
  this.selectedSQACode="";
  this.selectedPac = "";
  this.Is2ComboOptionSelected = true;
  if (this.checklist && this.checklist) {
    let item: SelectItem = this.checklist.find(s => s.value == this.selectedCheckList);

    //let summaryIssueText="";
    // if (item)
    // summaryIssueText = item.label;

    this.selectPacChecklistService=item.label;
  }
}
public onPacChange(){
  this.selectedCheckList="";
  this.selectedSQACode = "";
  this.Is2ComboOptionSelected = true;

  if (this.pacType && this.selectedPac) {
    let item: SelectItem = this.pacType.find(s => s.value == this.selectedPac);
    let summaryIssueText="";
    if (item)
    summaryIssueText = item.label;
    this.selectPacChecklistService=item.label;
    //load selected pac details.
    this.getPAC();
    this.getCommonQuestionValues1(1);
  this.getCommonQuestionValues3(3);
    //this.summaryIssueText=this.summaryIssueText+summaryIssueText;

  if ( this.selectedPac	== "1") { // Daily Disinfection

    this.Comment='Performed and completed selected ' + summaryIssueText + ' per Policy and Procedure';
    }
    else if ( this.selectedPac == "2") { // Portable RO Residual Chemical Verification
      this.Comment = 'Performed negative residual Peroxide verification and confirmed within acceptable range per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "3") { // Portable RO Disinfection

      this.Comment = 'Portable RO disinfection performed per location specific DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "4") { // Negative Residual Chemical Verification

      this.Comment = 'Performed selected negative residual chemical verification and confirmed within acceptable range per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "5") { // Dialysis Machine Disinfection Verification

      this.Comment = 'Dialysis Machine flow path disinfection performed per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "6") { // Dialysis Machine Descaling Verification

      this.Comment = 'Performed Dialysis Machine descaling per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "7") { // Device Surface Cleaning and Disinfection Verification

      this.Comment = 'Performed device surface cleaning and disinfection per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "8") { // Concentrate Wand Rinse/Disinfection

      this.Comment = 'Performed Concentrate Wand Rinse/Disinfection per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "9") { // Dialysis Machine Positive Chemical Verification

      this.Comment = 'Performed Dialysis Machine Positive Chemical Verification per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "10") { // Dialysis Machine AM Negative Residual Chemical Verification

      this.Comment = 'Performed dialysis machine AM negative residual chemical verification per DaVita Policy and Procedure.';
    }
    else if ( this.selectedPac == "11") { // End of Day Hardness Testing

      this.Comment = 'Performed end of day hardness testing per DaVita Policy and Procedure.';
    } 
    else if ( this.selectedPac == "12") { // CWP Chemical Disinfection

      this.Comment = 'Performed CWP Chemical Disinfection per DaVita Policy and Procedures.';
    } 
    else if ( this.selectedPac == "13") { // POST Negative Chemical Residual and Consumption Verification

      this.Comment = 'Performed negative residual Minncare verification and chemical consumption verification per DaVita Policy and Procedures.';
    }   		
    else {
      this.Comment = 'Performed and completed selected ' + summaryIssueText + ' per Policy and Procedure';
    }

  }
}



public setActivitiesCombo(){

  this.activityType = [];
  
  if (this.selectedData.length == 1) {
    //this.GETSERVICEREQSQACODES.equipmentTypeId = this.selectedData[0].EquipmentTypeID;
    this.getServiceReqSqaCodes();    
		this.activityType.push({ label: 'Service Request', value: '1'});  
  }
  this.activityType.push({ label: 'Pac', value: '2'}); 
  this.activityType.push({ label: 'Check List', value: '3'}); 
}

private MasterComboData(){
this.setActivitiesCombo(); 


  this.pacType = [];
  this.pacType.push({ label: 'Portable RO Negative Residual Chemical Verification', value: '2'}); 
  this.pacType.push({ label: 'Portable RO Disinfection', value: '3'}); 
  this.pacType.push({ label: 'Dialysis Machine Negative Residual Chemical Verification', value: '4'}); 
  this.pacType.push({ label: 'Dialysis Machine Flow Path Disinfection', value: '5'}); 
  this.pacType.push({ label: 'Dialysis Machine Descaling', value: '6'}); 
  // <cfif listFindNoCase('ADMIN,BSSX,CLNX,CLNSX,CLNLNX,LNX,BOMX',session.bartPrivs.bartRoleCode)>
  this.pacType.push({ label: 'Device Surface Cleaning and Disinfection', value: '7'}); 
  this.pacType.push({ label: 'Concentrate Wand Rinse/Disinfection', value: '8'}); 
  this.pacType.push({ label: 'Dialysis Machine Positive Chemical Verification', value: '9'}); 
  this.pacType.push({ label: 'Dialysis Machine AM Negative Residual Chemical Verification', value: '10'}); 
  this.pacType.push({ label: 'End of Day Hardness Testing', value: '11'}); 
  this.pacType.push({ label: 'CWP Chemical Disinfection', value: '12'}); 
  this.pacType.push({ label: 'CWP Negative Chemical Residual and Consumption Verification', value: '13'}); 

  this.checklist = [];
  this.checklist.push({label:"Daily Water Log", value:'1'});  
  

}
public loadDataOnScroll(event: LazyLoadEvent) {   
    setTimeout(() => {
    if (this.dataSource) {
      this.totalRecords=this.data.length;
      this.dataSource = this.data.slice(event.first, (event.first + event.rows));
    }
  
    this.loading = false;
    this.changeDetectorRef.detectChanges();
  }, 1000);
  
}

public getLocationCmobo(emittedLocationId: any){

}



/*
Prepare Data which is required for further use and not dependent on type
*/


public buildpac3_alternate(selequipment:any) {
  
 let html = "";
 let counter = 1;
 this.PaCHFRequired=false;
 let equipmentid = selequipment.EquipmentID;
 let element = this.selectedData.find(tt=>tt.EquipmentID == selequipment.EquipmentID)
 element.Param1Type="";
  element.Param2Type="";
 element.Param3Type="";
  element.Param4Type="";
  

 // Determine if this PAC has multiple questions
 let selQuestionID = "";
 let multiQuestionPAC = false;


 for(var curpacId of this.PacData) {
   if (selQuestionID == "") {
     selQuestionID = curpacId.PACQuestionID.toString();
   }
   else if (selQuestionID != curpacId.PACQuestionID.toString()) {
     multiQuestionPAC = true;
   }
 }

 selQuestionID = "";
 // html += '<tr bgcolor="yellow" id="pacresponse"><td colspan="10">';
 html += '<td colspan="10">';
 for (var curpacId of this.PacData) {		
   if (multiQuestionPAC) {
     if (selQuestionID == "") {
       html += curpacId.QuestionText + " ";
       selQuestionID = curpacId.PACQuestionID.toString();
     }
     else if (selQuestionID != curpacId.PACQuestionID.toString()) {
       html += "<br><br>" + curpacId.QuestionText + " ";
       selQuestionID = curpacId.PACQuestionID.toString();
     }
     if(this.selectedPac=="13")
     {
      if(counter==1)
      {
      element.Param1Type="radio";
      element.Param1ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
      element.Param1Value =curpacId.AnswerValue;
      element.Param1Status = "";
      element.QuestionText=curpacId.QuestionText;
      element.name1="PACID "+curpacId.PACQuestionID + "_" + equipmentid 
      }
      if(counter==2)
      {
      element.Param2Type="radio";
      element.Param2ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
      element.Param2Value =curpacId.AnswerValue;
      element.Param2Status = "";
      element.name2="PACID "+curpacId.PACQuestionID + "_" + equipmentid 
    //  element.QuestionText1=curpacId.QuestionText;
      }
      if(counter==3)
      {
      element.Param3Type="radio";
      element.Param3ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
      element.Param3Value = curpacId.AnswerValue;
      element.Param3Status = "";
      element.name3="PACID "+curpacId.PACQuestionID + "_" + equipmentid 
     // element.QuestionText=curpacId.QuestionText;
      }
      if(counter==4)
      {
      element.Param4Type="radio";
      element.Param4ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
      element.Param4Value =curpacId.AnswerValue;
      element.Param4Status = "";
      element.QuestionText1=curpacId.QuestionText;
      element.name4="PACID "+curpacId.PACQuestionID + "_" + equipmentid 
      }

     }
     else{
      
       
     element.Param1Type="radio";
     element.Param1ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
     element.Param1Value = curpacId.AnswerValue;
     element.Param1Status = "";

     html += "<span><input type='radio' id='" + counter + "PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "'/><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";			
     }
   }
   else {
     if (curpacId.ResponseTypeID == 1) {			
       // If acute and pacid 10 then select "< 0.5 ppm Total Chlorine & < 1 ppm Peroxide" and disable
       if (this.selectedPac == "10" && selequipment.equipmentModalityId == 2) {
         if (curpacId.PC_QuestionValueID == 24) {
           html += "<span><input type='radio' id='" + counter + "PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "' CHECKED DISABLED /><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";
                  if(counter==1) {
                  element.Param1Type="radio";
                  element.Param1ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                  element.Param1Value = curpacId.AnswerValue;
                  element.Param1Status = "CHECKED DISABLED";
                  }
                  if(counter==2) {
                    element.Param2Type="radio";
                    element.Param2ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                    element.Param2Value = curpacId.AnswerValue;
                    element.Param2Status = "CHECKED DISABLED";
                  }
                  if(counter==3) {
                    element.Param3Type="radio";
                    element.Param3ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                    element.Param3Value = curpacId.AnswerValue;
                    element.Param3Status = "CHECKED DISABLED";
                 }
                  if(counter==4) {
                    element.Param4Type="radio";
                    element.Param4ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                    element.Param4Value = curpacId.AnswerValue;
                    element.Param4Status = "CHECKED DISABLED";
                  }
                  if(counter==5) {
                    element.Param5Type="radio";
                    element.Param5ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                    element.Param5Value = curpacId.AnswerValue;
                    element.ParamStatus = "CHECKED DISABLED";
                  }
                  if(counter==6) {
                    element.Param6Type="radio";
                    element.Param6ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
                    element.Param6Value = curpacId.AnswerValue;
                    element.Param6Status = "CHECKED DISABLED";
                  }

          }
         else {
           html += "<span><input type='radio' id='" + counter + "PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "' DISABLED /><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";
           if(counter==1) {
            element.Param1Type="radio";
            element.Param1ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param1Value = curpacId.AnswerValue;
            element.Param1Status = "DISABLED";
            }
            if(counter==2) {
              element.Param2Type="radio";
              element.Param2ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
              element.Param2Value = curpacId.AnswerValue;
              element.Param2Status = "DISABLED";
            }
            if(counter==3) {
              element.Param3Type="radio";
              element.Param3ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
              element.Param3Value = curpacId.AnswerValue;
              element.Param3Status = "DISABLED";
           }
            if(counter==4) {
              element.Param4Type="radio";
              element.Param4ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
              element.Param4Value = curpacId.AnswerValue;
              element.Param4Status = "DISABLED";
            }
            if(counter==5) {
              element.Param5Type="radio";
              element.Param5ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
              element.Param5Value = curpacId.AnswerValue;
              element.ParamStatus = "DISABLED";
            }
            if(counter==6) {
              element.Param6Type="radio";
              element.Param6ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
              element.Param6Value = curpacId.AnswerValue;
              element.Param6Status = "DISABLED";
            }
         }
       }
       else {
           
         html += "<span><input type='radio' id='" + counter + "PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "'/><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";
         if(counter==1) {
          element.Param1Type="radio";
          element.Param1ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
          element.Param1Value = curpacId.AnswerValue;
          element.Param1Status = "";
          }
          if(counter==2) {
            element.Param2Type="radio";
            element.Param2ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param2Value = curpacId.AnswerValue;
            element.Param2Status = "";
          }
          if(counter==3) {
            element.Param3Type="radio";
            element.Param3ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param3Value = curpacId.AnswerValue;
            element.Param3Status = "";
         }
          if(counter==4) {
            element.Param4Type="radio";
            element.Param4ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param4Value = curpacId.AnswerValue;
            element.Param4Status = "";
          }
          if(counter==5) {
            element.Param5Type="radio";
            element.Param5ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param5Value = curpacId.AnswerValue;
            element.ParamStatus = "";
          }
          if(counter==6) {
            element.Param6Type="radio";
            element.Param6ID=equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID;
            element.Param6Value = curpacId.AnswerValue;
            element.Param6Status = "";
          }
       }				
     }	
   }		
   counter++;
 }

 html += "</td>";

 

 if (this.selectedPac == "7" && selequipment.equipmentModalityId == 2) {  // Only show questions for Device Surface Cleaning and Disinfection Verification & modality = 2
  this.PaCHepatitisBAntigenCombo = [];
  this.PaCHepatitisBAntigenComboSelectedValue="";
  this.PaCHepatitisBAntibodyCombo = [];  
  this.PaCHepatitisBAntibodyComboSelectedValue="";  
  this.PaCFlowsheetID="";
  this.PaCHFRequired=true;
    html += '<tr bgcolor="yellow"><td>Hepatitis B Antigen&nbsp;';
    html += '<td>Hepatitis B Antigen&nbsp;';
    html += "<select id='INFECTIONSTATUSID_" + equipmentid + "' name='INFECTIONSTATUSID_" + equipmentid + "'>";
   for (var nQuestionValues1 of this.CommonQuestionValues1) {	
    this.PaCHepatitisBAntigenCombo.push({ label: nQuestionValues1.ComAnswerValue, value:nQuestionValues1.PC_ComQuestionValueID});	
     html += "<option value='" + nQuestionValues1.PC_ComQuestionValueID + "'>" + nQuestionValues1.ComAnswerValue + "</option>";						
   }			
   html += "</select>";	
    html += "</td>";

    html += '<td colspan="4">Hepatitis B Antibody&nbsp;';
    html += "<select id='INFECTIONSTATUSID2_" + equipmentid + "' name='INFECTIONSTATUSID2_" + equipmentid + "'>";
   for (var uestionValues3 of this.CommonQuestionValues3) {		
    this.PaCHepatitisBAntibodyCombo.push({ label: uestionValues3.ComAnswerValue, value:uestionValues3.PC_ComQuestionValueID});	
     html += "<option value='" + uestionValues3.PC_ComQuestionValueID + "'>" + uestionValues3.ComAnswerValue + "</option>";						
   }			
    html += "</select>";	
    html += "</td>";	
 
    html += '<td colspan="5">Flowsheet ID&nbsp;';
    html += "<input type=text id='FLOWSHEETID_" + equipmentid + "' name='FLOWSHEETID_" + equipmentid + "' value='0000'>";
    html += "</td>";
   element.PaCFlowsheetID="0000";
 }	

 return html;
}

public onPaCHepatitisBAntigenComboChange(eventId: string){

}

public onPaCHepatitisBAntibodyComboChange(eventId: string){
  
}

 public buildpac3(selequipment:any) {
   
	let html = "";
	let counter = 1;
	
	// getCommonQuestionValues(1);	
	let equipmentid:number = selequipment.EquipmentID;
  let elemeent = this.selectedData.find(tt=>tt.EquipmentID == selequipment.EquipmentID)

	// Determine if this PAC has multiple questions
	let selQuestionID = "";
  let multiQuestionPAC = false;
 

	for(var curpacId of this.PacData) {
		if (selQuestionID == "") {
			selQuestionID = curpacId.PACQuestionID.toString();
		}
		else if (selQuestionID != curpacId.PACQuestionID.toString()) {
			multiQuestionPAC = true;
		}
	}

	selQuestionID = "";
  // html += '<tr bgcolor="yellow" id="pacresponse"><td colspan="10">';
  html += '<tr bgcolor="yellow" id="pacresponse"><td colspan="10">';
	for (var curpacId of this.PacData) {		
		if (multiQuestionPAC) {
			if (selQuestionID == "") {
				html += curpacId.QuestionText + " ";
				selQuestionID = curpacId.PACQuestionID.toString();
			}
			else if (selQuestionID != curpacId.PACQuestionID.toString()) {
				html += "<br><br>" + curpacId.QuestionText + " ";
				selQuestionID = curpacId.PACQuestionID.toString();
			}
			html += "<span><input type='radio' id='" + counter + "PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "'/><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";			
		}
		else {
			if (curpacId.ResponseTypeID == 1) {			
				// If acute and pacid 10 then select "< 0.5 ppm Total Chlorine & < 1 ppm Peroxide" and disable
				if (this.selectedPac == "10" && selequipment.equipmentModalityId == 2) {
					if (curpacId.PC_QuestionValueID == 24) {
						html += "<span><input type='radio' id='PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "' CHECKED DISABLED /><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";
					}
					else {
						html += "<span><input type='radio' id='PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "' DISABLED /><label onclick='' for='" + counter + "PACID_" + equipmentid + "'>" + curpacId.AnswerValue + "</label></span>";
					}
				}
				else {
					html += "<span><input type='radio' id='PACID_" + equipmentid + "' name='PACID" + curpacId.PACQuestionID + "_" + equipmentid + "' value='" + equipmentid + "*" + curpacId.PACQuestionID + "*" + curpacId.PC_QuestionValueID + "'/><label>" + curpacId.AnswerValue + "</label></span>";
				}				
			}	
		}		
		counter++;
	}

	html += "</td>";

	
	if (this.selectedPac == "7" && selequipment.equipmentModalityId == 2) { 
    
    // Only show questions for Device Surface Cleaning and Disinfection Verification & modality = 2
    this.PaCHFRequired=true;
    // html += '<tr bgcolor="yellow"><td>Hepatitis B Antigen&nbsp;';
    html += '<td>Hepatitis B Antigen&nbsp;';
		html += "<select id='INFECTIONSTATUSID_" + equipmentid + "' name='INFECTIONSTATUSID_" + equipmentid + "'>";
		for (var nQuestionValues1 of this.CommonQuestionValues1) {		
			html += "<option value='" + nQuestionValues1.PC_ComQuestionValueID + "'>" + nQuestionValues1.ComAnswerValue + "</option>";						
		}			
		html += "</select>";	
		html += "</td>";

		html += '<td colspan="4">Hepatitis B Antibody&nbsp;';
		html += "<select id='INFECTIONSTATUSID2_" + equipmentid + "' name='INFECTIONSTATUSID2_" + equipmentid + "'>";
		for (var uestionValues3 of this.CommonQuestionValues3) {		
			html += "<option value='" + uestionValues3.PC_ComQuestionValueID + "'>" + uestionValues3.ComAnswerValue + "</option>";						
		}			
		html += "</select>";	
		html += "</td>";	
	
		html += '<td colspan="5">Flowsheet ID&nbsp;';
		html += "<input type=text id='FLOWSHEETID_" + equipmentid + "' name='FLOWSHEETID_" + equipmentid + "' value='0000'>";
		html += "</td>";
		
	}	

	return html;
}

validatecl() {
	var success = true;
	for (let i=0;i< this.selectedData.length;i++) {
		if (this.selectedData[0].EquipmentSubTypeID != 3) {
      success = false;
      break;
		}
	}
	if (!success)
	{
		// $('#equipmentSearchGenericMessage').html('Only Primary Water Treatment equipment can be entered for this Checklist');
    // showBartDialog('equipmentSearchGenericDialog','Error');	
    this.ErrorMessage ='Only Primary Water Treatment equipment can be entered for this Checklist';
    this.ErrorDialoag=true;		
	}	
  return success;
  
}

validatepac() {

	var success = true;
	var pacSelected = Number(this.selectedPac);
	let facselected:any;

  for (let i=0;i< this.selectedData.length;i++) {
		if (facselected == null) {
			facselected = this.selectedData[i].facilityMasterid;
		}
		else if (facselected != this.selectedData[i].facilityMasterid) {
      success = false;
      break;
    }		
  
	}
	if (!success)
	{
  this.ErrorMessage ='Only equipment from one location can be entered for this PaC';
  this.ErrorDialoag=true;

		return success;	
	}

	if (pacSelected == 1) // Daily Disinfection
	{		
		for (let i=0;i< this.selectedData.length;i++){
			if (this.selectedData[i].EquipmentTypeID != 1) {
        success = false;
        break;
			}
		}
		if (!success)
		{
      this.ErrorMessage ='Only type 1 equipment can be entered for this PaC';
      this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 2) // Portable RO Residual Chemical Verification
	{
		for (let i=0;i< this.selectedData.length;i++){
			if (this.selectedData[i].EquipmentSubTypeID != 5) {
        success = false;
        break;
			}
		}
		if (!success)
		{
      this.ErrorMessage ='Only sub type 5 equipment can be entered for this PaC';
      this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 3) // Portable RO Disinfection
	{
		for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID != 5) {
        success = false;
        break;
			}
    }
    
		if (!success)
		{
			
      this.ErrorMessage ='Only subtype 5 equipment can be entered for this PaC';
      this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 4) // Negative Residual Chemical Verification
	{
		for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID  != 1) {
        success = false;
        break;
			}
		}
		if (!success)
		{
    this.ErrorMessage ='Only sub type 1 equipment can be entered for this PaC';
    this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 5) // Dialysis Machine Disinfection Verification
	{
		for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID!= 1) {
        success = false;
        break;
			}
		}
		if (!success)
		{
      this.ErrorMessage ='Only sub type 1 equipment can be entered for this PaC';
      this.ErrorDialoag=true;		
		}
	}
	else if (pacSelected == 6) // Dialysis Machine Descaling Verification
	{
		for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID != 1) {
        success = false;
        break;
			}
		}
		if (!success)
		{
      this.ErrorMessage ='Only sub type 1 equipment can be entered for this PaC';
      this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 7) // Device Surface Cleaning and Disinfection Verification
	{
			
	}
	else if (pacSelected == 8) // Concentrate Wand Rinse/Disinfection
	{
		for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID!= 1) {
        success = false;
        break;
			}
		}
		if (!success)
		{
      this.ErrorMessage ='Only sub type 1 equipment can be entered for this PaC';
      this.ErrorDialoag=true;	
		}
	}
	else if (pacSelected == 9) // Dialysis Machine Positive Chemical Verification
	{
    for (let i=0;i< this.selectedData.length;i++){
      if (this.selectedData[i].EquipmentSubTypeID!= 1) {
              success = false;
              break;
	        }
	    }
	    if (!success) {
          this.ErrorMessage ='Only sub type 1 equipment can be entered for this PaC';
          this.ErrorDialoag=true;	
	    }
	}
	else if (pacSelected == 10) // Dialysis Machine AM Negative Residual Chemical Verification
	{
    for (let i=0;i< this.selectedData.length;i++){
	        if (this.selectedData[i].EquipmentSubTypeID != 1) {
              success = false;
              break;
	        }
	    }
	    if (!success) {
          this.ErrorMessage ='Only type 1 equipment can be entered for this PaC';
          this.ErrorDialoag=true;	
	    }
	}
	else if (pacSelected == 11) // End of Day Hardness Testing
	{
    for (let i=0;i< this.selectedData.length;i++){
	        if (this.selectedData[i].PACList.split(',').indexOf(pacSelected.toString()) < 0) { 
              success = false;
              break;
	        }
	    }
	    if (!success) {
          this.ErrorMessage ='This activity can only be performed on the water softener tank';
          this.ErrorDialoag=true;	
	    }
	}
	else if (pacSelected == 12) // CWP Chemical Disinfection
	{
    for (let i=0;i< this.selectedData.length;i++){
      let pacindex=this.selectedData[i].PACList.split(',');
	        if (pacindex.indexOf(pacSelected.toString()) < 0) { 
              success = false;
              break;
	        }
	    }
	    if (!success) {
          this.ErrorMessage ='This activity can only be performed on CWP';
          this.ErrorDialoag=true;	
	    }
	}
	else if (pacSelected == 13) // POST Negative Chemical Residual and Consumption Verification
	{
    for (let i=0;i< this.selectedData.length;i++){
	        if (this.selectedData[i].PACList.split(',').indexOf(pacSelected.toString()) < 0) { 
              success = false;
              break;
	        }
	    }
	    if (!success) {
          this.ErrorMessage ='This activity can only be performed on CWP';
          this.ErrorDialoag=true;	
	    }
	}
	return success;
}

async builddelayreason_alternate(){
  
   var result= await this.getDelayReasons();
   
  this.DelayReasonCombo = [];
  for (let c of this.DelayReasons) {
    this.DelayReasonCombo.push({ label: c.DelayReasonText, value:c.DelayReason_ID});
  }
  this.DelayReasonComboSelectedValue = "NA";

  let counter = 1;	
	let currDate = new Date();
	var year = currDate.getFullYear();
	var month = (1 + currDate.getMonth()).toString();
	month = month.length > 1 ? month : '0' + month;
	var day = currDate.getDate().toString();
	day = day.length > 1 ? day : '0' + day;
  this.IntendedDate=month + "/" + day + "/" + year;
	counter = 0;
  let hour = "";
  this.DelayReasonHoursCombo = [];
	while (counter < 24) {
		hour = counter > 9 ? "" + counter: "0" + counter
		if (counter == currDate.getHours()) {
      this.DelayReasonHoursCombo.push({ label: hour, value:hour});
      this.DelayReasonHoursComboSelectedValue = hour;
		}
		else {
      this.DelayReasonHoursCombo.push({ label: hour, value:hour});
		}
		counter++
	}
  this.DelayReasonMinutesCombo = [];
	counter = 0;
	while (counter < 60) {
		let min = counter > 9 ? "" + counter: "0" + counter
		if (counter == currDate.getMinutes()) {
      this.DelayReasonMinutesCombo.push({ label: min, value:min});
      this.DelayReasonMinutesComboSelectedValue = min;
		}
		else {
      this.DelayReasonMinutesCombo.push({ label: min, value:min});
		}
		counter++
  }
  
}
public builddelayreason() {
 
	let html = "";
	let counter = 1;
	
	let currDate = new Date();
	var year = currDate.getFullYear();
	var month = (1 + currDate.getMonth()).toString();
	month = month.length > 1 ? month : '0' + month;
	var day = currDate.getDate().toString();
	day = day.length > 1 ? day : '0' + day;

	html += '<tr><td>Delay Reason: <select name="delayreason" id="delayreason">'
	for (var curpacId of this.DelayReasons) {	
		html += '<option value="' + curpacId.DelayReason_ID + '">' + curpacId.DelayReasonText + '</option>'
	}
	//html += '<option value="1">1</option>'	
	html += '</select></td>'	

	html += '<td>Intended Date: <input type="text" id="intendeddate" value="' + month + "/" + day + "/" + year + '"> <img src="./images/calendar.gif" id="pickIntendedDate">&nbsp;'	
	
	html += 'Time: <select name="intendedhour" id="intendedhour">'
	counter = 0;
	let hour = "";
	while (counter < 24) {
		hour = counter > 9 ? "" + counter: "0" + counter
		if (counter == currDate.getHours()) {
			html += '<option value="' + hour + '" SELECTED>' + hour + '</option>'
		}
		else {
			html += '<option value="' + hour + '">' + hour + '</option>'
		}
		counter++
	}
	html += '</select>'	
	html += '&nbsp;<select name="intendedmin" id="intendedmin">'
	counter = 0;
	while (counter < 60) {
		let min = counter > 9 ? "" + counter: "0" + counter
		if (counter == currDate.getMinutes()) {
			html += '<option value="' + min + '" SELECTED>' + min + '</option>'
		}
		else {
			html += '<option value="' + min + '">' + min + '</option>'
		}
		counter++
	}
	html += '</select></td></tr>'	

  return html;
	
}

public calcDiff1()
{
  alert('hi')
}


 public calcDiff(Formula:any)
{

  var ArrayFromString = Formula.split("|");
 let valA:any=ArrayFromString[0];
 let valB:any=ArrayFromString[1];
 let valC:any=ArrayFromString[2];
 let valAA:any=ArrayFromString[3];
 let valBB:any=ArrayFromString[4];
 let valCC:any=ArrayFromString[5];
 let A:any=((<HTMLInputElement>document.getElementById("CheckListID"+valA+"_"+valAA)).value);
 let B:any=((<HTMLInputElement>document.getElementById("CheckListID"+valB+"_"+valBB)).value);

 let c:any=A-B;
 if(!isNaN(c))
 {
 ((<HTMLInputElement>document.getElementById("CheckListID"+valC+"_"+valCC)).value)=c;
 }
 else{
  ((<HTMLInputElement>document.getElementById("CheckListID"+valC+"_"+valCC)).value)='0';
 }
}



async buildchecklist_alternate() {
  
  this.buildCheckList_Data = [];

	let html = "";
	let FORMULA = {}; 

	var k = 0;
	var j = 0;
	
	// Apply relative question logic
		for(var cupid in this.selectedData)
    var result=await this.getChecklist(this.selectedData[cupid].EquipmentID,70)
    
  for (var curchecklistId of this.checlistData) {	
		if (curchecklistId.DataType == 'Decimal' && curchecklistId.Formula != null) {
			FORMULA[k] = {					
					Text:curchecklistId.Formula,
					Output:curchecklistId.QuestionID,
					Equip:curchecklistId.EquipmentID
					};				
			k++;											
    }
  }
	
	
	while (j < k) {
    if(FORMULA[j].Text!=null){
      var ArrayFromString = FORMULA[j].Text.split("-");
      FORMULA[j].ValueA = ArrayFromString[0].substr(1,ArrayFromString[0].length); // remove colon
      FORMULA[j].ValueB = ArrayFromString[1];	
    }
		j++;

	}

  html += '<tr><td>';
	html += '<table border=1 width=100%>';
	html += '<tr><td></td><td>Monitored Process or Component</td><td>Result</td><td>UOM</td><td style=width:10%>Acceptable Limits</td><td>Monitor Location</td></tr>';

  
	var i = 1;		
	var checklistCompleted = 0;
	
	for (var curchecklistId of this.checlistData) {	
    
    let item = {
      rowID:'',
      rowNumber:'',
      MonitoredProcessorComponent:'',
      Result:'',
      UOM:'',
      AcceptableLimits:'',
      MonitorLocation:'',
      controlType:'',
      disabled:'',
      functionCall:'',
      Checked:'',
      ControlID:'',
      ResultRadio1:'',
      ResultRadio2:'',
      ControlIDRadio1:'',
      ControlIDRadio2:'',
      ResultRadio3:'',
      ControlIDRadio3:'',
      Block:'',
      DataType:'',
      Formula:'',
      Name:'',
      ResponseText:''
      //Result1:'',
      //Result2:''
    }
   
		curchecklistId.RowNum = i;
		if (curchecklistId.ResponseText != null) {
			checklistCompleted = 1
		}
    html += '<tr id="row_'+curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID +'">';
    item.rowID="row_"+curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
    html += "<td>" + i + "</td>";	
    item.rowNumber=""+i+"";

    html += "<td style='height:41px;'>" + curchecklistId.QuestionText + "</td>";
    item.MonitoredProcessorComponent = curchecklistId.QuestionText;
    item.DataType=curchecklistId.DataType;
    item.Formula=curchecklistId.Formula;
    item.Name=curchecklistId.Name;
    item.ResponseText=curchecklistId.ResponseText;
		if (curchecklistId.DataType == 'Decimal' && curchecklistId.Formula != null) {
			html += "<td><input type=text style='width:240px;' class='ng-pristine ng-valid ui-inputtext ui-corner-all ui-state-default ui-widget ng-touched' id='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "'" + " DISABLED";
      item.ControlID = "CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
      item.Block="1";
      item.ResponseText="";
      if (curchecklistId.ResponseText != null ) {
        item.controlType='text';
        item.Result = curchecklistId.ResponseText;  
             
        item.disabled = 'DISABLED';
				html += " value = '" + curchecklistId.ResponseText + "'"
			}
			if (curchecklistId.ResponseText == '0' || curchecklistId.ResponseText == null) {	// Javascript handles zero like an empty string so we must add a special condition to check for zero
        //html += " value = 0"
        item.controlType='text';
        item.Result = '';
        //item.disabled = 'ENABLED';

			}	
			html += "></td>"			
		}		
		else if (curchecklistId.DataType == 'Decimal' || curchecklistId.DataType == 'Time' || curchecklistId.DataType == 'String') {
			html += "<td><input type=text style='width: 240px;' class='ng-pristine ng-valid ui-inputtext ui-corner-all ui-state-default ui-widget ng-touched' id='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "'"
      item.ControlID = "CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
      
      item.Block="2";
      if ( curchecklistId.ResponseText != null) {
        item.controlType='text';
        item.Result = curchecklistId.ResponseText;
				html += " value = '" + curchecklistId.ResponseText + "'"
			} 
			if (curchecklistId.ResponseText == '0' || curchecklistId.ResponseText == null) {	// Javascript handles zero like an empty string so we must add a special condition to check for zero
        //html += " value = 0"
        item.controlType='text';
        item.Result = '';
        //item.disabled="ENABLED"
			}
			// if (curchecklistId.ResponseText != '' || curchecklistId.ResponseText == '0') {
        if (curchecklistId.ResponseText != null) {
          item.disabled = 'DISABLED';
				html += " DISABLED"
			}
			j = 0;
			while (j < k) {
				if ((FORMULA[j].ValueA == curchecklistId.QuestionID || FORMULA[j].ValueB == curchecklistId.QuestionID) && FORMULA[j].Equip == curchecklistId.EquipmentID)
				{
          item.functionCall =  FORMULA[j].ValueA +"|" + FORMULA[j].ValueB + "|" + FORMULA[j].Output + "|" + FORMULA[j].Equip + "|" + FORMULA[j].Equip + "|" + FORMULA[j].Equip;
          html += "  data='"+FORMULA[j].ValueA +"|" + FORMULA[j].ValueB + "|" + FORMULA[j].Output + "|" + FORMULA[j].Equip + "|" + FORMULA[j].Equip + "|" + FORMULA[j].Equip +"'"
          html+="name='txtchekResult'"
          item.Block="5";
          //item.functionCall="txtchekResult"
					break;//onchange='calcDiff(" + FORMULA[j].ValueA + "," + FORMULA[j].ValueB + "," + FORMULA[j].Output + "," + FORMULA[j].Equip + "," + FORMULA[j].Equip + "," + FORMULA[j].Equip + ")'";
				}
				j++; 	
			}
			
			html += "></td>"
		}
		else if (curchecklistId.DataType == 'Boolean' && curchecklistId.Name == 'Y/N') {
      item.Block="3";
			html += "<td>"
      html += "<input type=radio id='YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='Y'" 
      item.controlType='radio';
      item.ResultRadio1 = "Y";
      item.Result = curchecklistId.ResponseText;
      item.ControlIDRadio1 = "YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
			if (curchecklistId.ResponseText == 'Y') {
        html += " CHECKED"
        item.Checked = "CHECKED";
			}
			if (curchecklistId.ResponseText != '' && curchecklistId.ResponseText != null) {
        html += " DISABLED"
        item.disabled="DISABLED";
			}
      html += "> Y" 

      item.ResultRadio2 = "N";
      item.ControlIDRadio2 = "NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;

			html += "<input type=radio id='NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='N'" 
			if (curchecklistId.ResponseText == 'N') {
        item.Checked = "CHECKED";
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '' && curchecklistId.ResponseText != null) {
        item.disabled="DISABLED";
				html += " DISABLED"
			}
			html += "> N" 			
			html += "</td>"
		}		
		
		else if (curchecklistId.DataType == 'Boolean' && curchecklistId.Name == 'Y/N/NA') {		
      item.Block="4";
			html += "<td>"
			html += "<input type=radio id='YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='Y'" 
      item.Result = curchecklistId.ResponseText;
      item.ResultRadio1 = "Y";
      item.controlType='radio';
      item.ControlIDRadio1 = "YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
      if (curchecklistId.ResponseText == 'Y') {
        item.Checked = "CHECKED";
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '' && curchecklistId.ResponseText != null) {
        item.disabled="DISABLED";
				html += " DISABLED"
			}
			html += "> Y" 
      html += "<input type=radio id='NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='N'" 
      
      item.ResultRadio2 = "N";
      item.ControlIDRadio2 = "NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;

			if (curchecklistId.ResponseText == 'N') {
        html += " CHECKED"
        item.Checked = "CHECKED";
			}
			if (curchecklistId.ResponseText != '' && curchecklistId.ResponseText != null) {
        html += " DISABLED"
        item.disabled="DISABLED";
			}
			html += "> N" 	
      html += "<input type=radio id='NACheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='NA'" 
      item.ResultRadio3 = "NA";
      item.ControlIDRadio3 = "NACheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID;
			if (curchecklistId.ResponseText == 'NA') {
        html += " CHECKED",
        item.Checked = "CHECKED";
			}
			if (curchecklistId.ResponseText != '' && curchecklistId.ResponseText != null) {
        html += " DISABLED",
        item.disabled="DISABLED";
			}
			html += "> NA" 		
			html += "</td>"
		}
       
    item.UOM=curchecklistId.Symbol;
    item.AcceptableLimits=curchecklistId.AcceptableRange;
    item.MonitorLocation=curchecklistId.MonitorLocation;

    this.buildCheckList_Data.push(item);
    
		html += "<td>" + curchecklistId.Symbol + "</td>";
		html += "<td>" + curchecklistId.AcceptableRange + "</td>";
		html += "<td>" + curchecklistId.MonitorLocation + "</td>";
		html += "</tr>";

    i++;	
    
	}
	html += '</table>';
	html += '</td></tr>';

  return html;
  
}

// Add TextBox Change Event
checkListResultTextBox: any;
public attachClickEventforOpenTicketSummary() {
  
  // Solution for catching click events on anchors using querySelectorAll:
  this.checkListResultTextBox = this.elementRef.nativeElement.querySelectorAll('input[name="txtchekResult"]');
  this.checkListResultTextBox.forEach((txtChecklitResult: HTMLInputElement) => {
    txtChecklitResult.addEventListener('change', this.handleAnchorClick)
  })
}

public ngOnDestroy() {
  // Cleanup by removing the event listeners on destroy
  if(this.checkListResultTextBox!=null && this.checkListResultTextBox!=undefined)
  {
  this.checkListResultTextBox.forEach((anchor: HTMLAnchorElement) => {
    anchor.removeEventListener('change', this.handleAnchorClick)
  })
}
}
public handleAnchorClick = (event: Event) => {
  // Prevent opening anchors the default way
  
  const txtBox = event.target as HTMLInputElement;
  let valueList=txtBox.getAttribute("data")
 // this.calcDiff()
 var ArrayFromString = valueList.split("|");
 let valA:any=ArrayFromString[0];
 let valB:any=ArrayFromString[1];
 let valC:any=ArrayFromString[2];
 let valAA:any=ArrayFromString[3];
 let valBB:any=ArrayFromString[4];
 let valCC:any=ArrayFromString[5];
 let A:any=((<HTMLInputElement>document.getElementById("CheckListID"+valA+"_"+valAA)).value);
 let B:any=((<HTMLInputElement>document.getElementById("CheckListID"+valB+"_"+valBB)).value);
 let c:any=A-B;
 ((<HTMLInputElement>document.getElementById("CheckListID"+valC+"_"+valCC)).value)=c;
  //this.router.navigate(['/tickets'], { queryParams: { ticketId: ticketId } });
}
  




public buildchecklist() {
	let html = "";
	let FORMULA = {}; 

	var k = 0;
	var j = 0;
	this.getChecklist(489605,70)
	// Apply relative question logic
	for (var curchecklistId of this.checlistData) {		

		if (curchecklistId.DataType == 'Decimal' && curchecklistId.Formula != '') {
			FORMULA[k] = {					
					Text:curchecklistId.Formula,
					Output:curchecklistId.QuestionID,
					Equip:curchecklistId.EquipmentID
					};				
			k++;											
		}
	}	
	
	while (j < k) {
    if(FORMULA[j].Text!=null){
      var ArrayFromString = FORMULA[j].Text.split("-");
      FORMULA[j].ValueA = ArrayFromString[0].substr(1,ArrayFromString[0].length); // remove colon
      FORMULA[j].ValueB = ArrayFromString[1];	
    }
		j++;

	}

  html += '<tr><td>';
	html += '<table border=1 width=100%>';
	html += '<tr><td></td><td>Monitored Process or Component</td><td>Result</td><td>UOM</td><td>Acceptable Limits</td><td>Monitor Location</td></tr>';

	var i = 1;		
	var checklistCompleted = 0;
	
	for (var curchecklistId of this.checlistData) {		
		curchecklistId.RowNum = i;
		if (curchecklistId.ResponseText != '') {
			checklistCompleted = 1
		}
		html += '<tr id="row_'+curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID +'">';
		html += "<td>" + i + "</td>";	
		html += "<td>" + curchecklistId.QuestionText + "</td>";
		if (curchecklistId.DataType == 'Decimal' && curchecklistId.Formula != '') {
			html += "<td width=50><input type=text id='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "'" + " DISABLED";	
			if (curchecklistId.ResponseText != '') {
				html += " value = '" + curchecklistId.ResponseText + "'"
			}
			if (curchecklistId.ResponseText == '0') {	// Javascript handles zero like an empty string so we must add a special condition to check for zero
				html += " value = 0"
			}	
			html += "></td>"			
		}		
		else if (curchecklistId.DataType == 'Decimal' || curchecklistId.DataType == 'Time' || curchecklistId.DataType == 'String') {
			html += "<td width=50><input type=text id='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID  + "_" + curchecklistId.EquipmentID + "'"
			if (curchecklistId.ResponseText != '') {
				html += " value = '" + curchecklistId.ResponseText + "'"
			}
			if (curchecklistId.ResponseText == '0') {	// Javascript handles zero like an empty string so we must add a special condition to check for zero
				html += " value = 0"
			}
			// if (curchecklistId.ResponseText != '' || curchecklistId.ResponseText == '0') {
        if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			j = 0;
			while (j < k) {
				if ((FORMULA[j].ValueA == curchecklistId.QuestionID || FORMULA[j].ValueB == curchecklistId.QuestionID) && FORMULA[j].Equip == curchecklistId.EquipmentID)
				{
          
					html += " '('onchange')'='calcDiff(" + FORMULA[j].ValueA + "," + FORMULA[j].ValueB + "," + FORMULA[j].Output + "," + FORMULA[j].Equip + "," + FORMULA[j].Equip + "," + FORMULA[j].Equip + ")'";
					break;
				}
				j++; 	
			}
			
			html += "></td>"
		}
		else if (curchecklistId.DataType == 'Boolean' && curchecklistId.Name == 'Y/N') {
			html += "<td width=50>"
			html += "<input type=radio id='YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='Y'" 
			if (curchecklistId.ResponseText == 'Y') {
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			html += "> Y" 
			html += "<input type=radio id='NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='N'" 
			if (curchecklistId.ResponseText == 'N') {
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			html += "> N" 			
			html += "</td>"
		}		
		
		else if (curchecklistId.DataType == 'Boolean' && curchecklistId.Name == 'Y/N/NA') {				
			html += "<td width=50>"
			html += "<input type=radio id='YCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='Y'" 
			if (curchecklistId.ResponseText == 'Y') {
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			html += "> Y" 
			html += "<input type=radio id='NCheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='N'" 
			if (curchecklistId.ResponseText == 'N') {
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			html += "> N" 	
			html += "<input type=radio id='NACheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' name='CheckListID" + curchecklistId.QuestionID + "_" + curchecklistId.EquipmentID + "' value='NA'" 
			if (curchecklistId.ResponseText == 'NA') {
				html += " CHECKED"
			}
			if (curchecklistId.ResponseText != '') {
				html += " DISABLED"
			}
			html += "> NA" 		
			html += "</td>"
		}
					
		html += "<td>" + curchecklistId.Symbol + "</td>";
		html += "<td>" + curchecklistId.AcceptableRange + "</td>";
		html += "<td>" + curchecklistId.MonitorLocation + "</td>";
		html += "</tr>";

		i++;	
	}

	html += '</table>';
	html += '</td></tr>';

	//$("#checklistBody tbody").html(html);	
  return html;
}



/* Service Calls  Start Here*/


getFacilityEquipmentManager() {
  if (this.GETFACILITYEQUIPMENTMANAGER != null  ) {
    this.gridloading = true;
    let GETFACILITYEQUIPMENTMANAGER = this.GETFACILITYEQUIPMENTMANAGER;
    this.GETFACILITYEQUIPMENTMANAGER.Username= this.userDetail.userId.toString();
    this._EquipmentService.getFacilityEquipmentManager(JSON.stringify({GETFACILITYEQUIPMENTMANAGER}) )
    .subscribe((allUserLocationsResponse: any) =>{
      //this.userLocations = allUserLocationsResponse.response;
      
      this.data  = [];
      if(allUserLocationsResponse!=null)
      {
        let userFacilitiesResp = allUserLocationsResponse["facilityEquipment"]
        for (let c of userFacilitiesResp) {
          this.data.push({ facilityName: c.facilityName, MachineNickName:c.MachineNickName,facilityMasterid:c.facilityMasterid, regionMasterId:c.regionMasterId,regionName:c.regionName,
            divisionMasterId:c.divisionMasterId, divisionName:c.divisionName, facilityNumber:c.facilityNumber,EquipmentID:c.EquipmentID,locationtypeid:c.locationtypeid, locationName:c.locationName,
            ModelID:c.ModelID, EquipmentSerialNumber:c.EquipmentSerialNumber, clockhours:c.clockhours, equipmentDescription:c.equipmentDescription, DateOfOriginalInstall:c.DateOfOriginalInstall, DateOfLastRepair:c.DateOfLastRepair,
            DateModified:c.DateModified, DateWarrantyExpires:c.DateWarrantyExpires, DateOfLastPM:c.DateOfLastPM, modifiedby:c.modifiedby,equipmentModalityId:c.equipmentModalityId, isCustomScheduleActiveFlag:c.isCustomScheduleActiveFlag, status:c.status,
            ModelDescription:c.ModelDescription, modelNumber:c.modelNumber, EquipmentTypeID:c.EquipmentTypeID, EquipmentSubTypeID:c.EquipmentSubTypeID, ManufacturerID:c.ManufacturerID, IsNickNameEnabled:c.IsNickNameEnabled,
            ManufacturerName:c.ManufacturerName, EquipmentTypeDescription:c.EquipmentTypeDescription, EquipmentSubTypeDescription:c.EquipmentSubTypeDescription,
            equipmentstatusid:c.equipmentstatusid, fullname:c.fullname, modalityDescription:c.modalityDescription, equipmentConditionId: c.equipmentConditionId, equipmentCondition:c.equipmentCondition, equipmentOriginId:c.equipmentOriginId,
            equipmentOrigin:c.equipmentOrigin, MPI:c.MPI, PACList:c.PACList, IsIpAddressEnabled:c.IsIpAddressEnabled, MachineIPAddress:c.MachineIPAddress,
            Facility:c.facilityNumber+"-"+ c.facilityName,
            Param1Type:'',  Param1ID:'',  Param1Value:'', Param1Status:'0', Param1SelectValue:'',Param2Type:'',  Param2ID:'',  Param2Value:'', Param2Status:'', Param2SelectValue:'', Param3Type:'',  Param3ID:'',  Param3Value:'', Param3Status:'',
            Param4Type:'',  Param4ID:'',  Param4Value:'', Param4Status:'', Param5Type:'',  Param5ID:'',  Param5Value:'',  Param5Status:'',Param6Type:'',  Param6ID:'',  Param6Value:'',Param6Status:''
            ,PaCFlowsheetID:'',PaCHepatitisBAntigendValue:'', PaCHepatitisBAntibodyValue:'',
            ReferenceNo:'N/A',createdate:''
          });;
        }        
      }
      this.gridloading = false;
      this.changeDetectorRef.detectChanges();
      }, 
      (error) => 
      {
        console.log(error);
        this.data = [];
        this.gridloading=false
        this.changeDetectorRef.detectChanges();
        // handle error here
      }
    );
  }
  
}

// GetFilteredFacilityDetails() {
//   if (this.getSystemXDashboardParam != null) {
//     this.loading = true;
//     this._SystemxService.GetFilteredFacilityDetails(this.getSystemXDashboardParam)
//     .subscribe((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
//         this.data = allSystemXDetailResponse['response'];
//         this.dataSource = this.data;
//         this.totalRecords = this.data.length;
//       }, (respose: Response) => {
//         this.data = [];
//         // handle error here
//       }
//     );
//   }
// }

getServiceReqSqaCodes() {
  let equipmentTypeID = 1;

  if(this.selectedData.length>0)
      equipmentTypeID = this.selectedData[0].EquipmentTypeID;
  
  let  GETSERVICEREQSQACODES = {
    equipmentTypeId:equipmentTypeID
  }
  if (this.SQACodeList==null && GETSERVICEREQSQACODES != null && GETSERVICEREQSQACODES != null ) {
    this._sqacodeService.getServiceReqSqaCodes(JSON.stringify({GETSERVICEREQSQACODES}) )
    .subscribe((allUserLocationsResponse: any) =>{
      //this.userLocations = allUserLocationsResponse.response;
     
      this.SQACodeList = [];
      if(allUserLocationsResponse!=null)
      {
        let userFacilitiesResp = allUserLocationsResponse
        for (let c of userFacilitiesResp) {
          this.SQACodeList.push({ label: c.sqaWebFormText, value:c.SQACodeId});;
        }
      }        
      }, (respose: Response) => {
        this.SQACodeList = [];
        // handle error here
      }
    );
  }
  
}

public getCommonQuestionValues1(questionId:any) {

  let GETCOMMONQUESTIONVALUES: any= {
    comquestionid: questionId   
  };

  if (GETCOMMONQUESTIONVALUES != null) 
  {
    this._PacService.getCommonQuestionValues(JSON.stringify({GETCOMMONQUESTIONVALUES}))
    .subscribe((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
        this.CommonQuestionValues1 = allSystemXDetailResponse["pac"];  
 
      }, 
      (respose: Response) => {
        this.CommonQuestionValues1 = [];        
      }
    );
  }
}

public getCommonQuestionValues3(questionId:any) {

  let GETCOMMONQUESTIONVALUES: any= {
    comquestionid: questionId   
  };

  if (GETCOMMONQUESTIONVALUES != null) 
  {
    this._PacService.getCommonQuestionValues(JSON.stringify({GETCOMMONQUESTIONVALUES}))
    .subscribe((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
      this.CommonQuestionValues3= allSystemXDetailResponse["pac"]; 
    
      }, 
      (respose: Response) => {
        this.CommonQuestionValues3 = [];        
      }
    );
  }
}

async getDelayReasons() {
var result=false;
  let GETDELAYREASONS: any= {
  };
  if (GETDELAYREASONS != null) 
  {
   await  this._PacService.getDelayReasonsasync(JSON.stringify({GETDELAYREASONS}))
    .then((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
      this.DelayReasons = allSystemXDetailResponse["pac"]; 
      result=true;
     
      }, 
      (respose: Response) => {
        this.DelayReasons = [];        
      }
    );
  }
  return  result;
}

public getPAC() {
var success=false;
  let GETPAC: any= {
    pacId:this.selectedPac
  };

  if (GETPAC != null) 
  {
    this._PacService.getPAC(JSON.stringify({GETPAC}))
    .subscribe((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
      
      this.PacData = allSystemXDetailResponse["pac"]; 
      success=true;
     

      }, 
      (respose: Response) => {
        this.PacData = [];        
      }
    );
  }
  return success;
}
createpacgrouplist:any[];
async getcreatepacGroup() {
  var result=false
  
  for(let i=0;i<=this.selectedData.length;i++)
  { 
  let CREATEPACGROUP= {
    EquipmentID: this.selectedData[i].EquipmentID,
    FacilitymasterID: this.selectedFacility,
    PACID: this.selectedPac,
    UserID: this.userDetail.userId,
    IntendedDate: "2018-10-18 14:40:00.000",
    //IntendedDate:this.IntendedDate +""+ this.DelayReasonMinutesComboSelectedValue,
    DelayReason:3
    // this.DelayReasonComboSelectedValue
}
let CREATEPACGROUPINFECTION= {
    RESPONSE:878,
    ComQuestionID:1

}
let CREATEPACGROUPINFECTION2={
    RESPONSE:878,
    ComQuestionID:1

}
let CREATEPACGROUPFLOWSHEET= {
    RESPONSE:878,
    ComQuestionID:1
}
    this.createpacgrouplist=[];
    if (CREATEPACGROUP != null) 
    {
      await this._PacService.createPACGroupasync(JSON.stringify({CREATEPACGROUP,CREATEPACGROUPINFECTION,CREATEPACGROUPINFECTION2,CREATEPACGROUPFLOWSHEET}))
      .then((resp:any) => {
        var value=new Array();
        value=resp.pac
        //var al=resp[0];
        this.responsemasterid=resp.pac;
         this.getcreatePACResponse();
        //this.createpacgrouplist= resp;
        //for(var item of resp)
      
        
        }, 
        
      );
    }
     return result
  
  }
}

  async getcreatePACResponse() {
    var result=false
    
      let CREATEPACRESPONSE: any= {
        PC_ResponseMasterID:this.responsemasterid,
        PACQuestionID:7,
        Response:18
      };
      this.createpacgrouplist=[];
      if (CREATEPACRESPONSE != null) 
      {
        await this._PacService.createPACResponseasync(JSON.stringify({CREATEPACRESPONSE}))
        .then((resp: Array<any>) => {
          this.createpacgrouplist= resp;
         
          }, 
          
        );
      }
       return result
    
    }

async getChecklist(equipmentID:number,waterLogID:number) {
var result=false
  let GETCHECKLIST: any= {
    EquipmentID:equipmentID,
    WaterLogID:'',
    RoleID:70
  };
  this.checlistData=[];
  if (GETCHECKLIST != null) 
  {
    await this._ChecklistService.getChecklistasync(JSON.stringify({GETCHECKLIST}))
    .then((checlist: Array<CHECKLIST_Model>) => {
      if(this.checlistData!=undefined && this.checlistData.length>0)
      {
          this.checlistData.push(...checlist);
          result=true;
      }
      else
      {
          this.checlistData= checlist;
      }
      }, 
      (respose: Response) => {
        this.checlistData = [];        
      }
    );
  }
 	return result

}

serviceRequesttList:any[];
facilityMasterIdList:string;


 getServiceRequestsNew() {

var valid = 1;

  let GETSERVICEREQUEST :any= {    
   serviceRequestId:null,
   WorkTypeID:null,
   sqaCodeId:this.selectedSQACode,
   equipmentId:this.selectedData[0].EquipmentID,
   facilityMasterIdList:this.selectedData[0].facilityMasterid,
   RequestStatusID:2,
   returnTotalCount:null,
   returnAllRecords:1,
   maxRecords:50,
   orderBy:"dateServiceDue ASC, serviceRequestId ASC",
   searchTerm:''
   }

   var GETUSERFACILITIES :any=  {
    USERNAME: this.userDetail.userName
}
  //  var getServiceRequest= dashServiceRequestParam + GETUSERFACILITIES;
   this.serviceRequesttList=null
if (GETSERVICEREQUEST != null) {
     this.loading = true;
     this.sRequest.getServiceRequest(JSON.stringify({GETSERVICEREQUEST,GETUSERFACILITIES}))
     .subscribe((resp: Array<any>) => {
       
         this.serviceRequesttList=resp;
         if(resp==[] || resp.length===0)
         {
          valid=0;
        
            
         }
         this.changeDetectorRef.detectChanges();
       }, 
       (error) => 
       {
         this.serviceRequesttList = [];
         this.changeDetectorRef.detectChanges();
         // handle error here
       }
     );

    }
    return valid;
 }

 


 public validatechecklistform() 
 {
	var success = true;
  
	 let selQuestionID:any="";
	  let errorQuestionID:any="";
	  for (var curchecklistId in this.checlistData) {
		if (selQuestionID ==""  || selQuestionID != this.checlistData[curchecklistId].QuestionID) {
	 		selQuestionID = this.checlistData[curchecklistId].QuestionID;
			if (this.checlistData[curchecklistId].DataType == 'Time' || this.checlistData[curchecklistId].DataType == 'String') {
				// if ($('#CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).val().length == 0) {
          if (((<HTMLInputElement>document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).value).length == 0) {
				 	success = false;
	 			 	errorQuestionID += this.checlistData[curchecklistId].RowNum + '. ' + this.checlistData[curchecklistId].QuestionText + '.<br>';	
	 			 	document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).style.border = "1px solid red";
	 			 }
	 		 else {
        ((<HTMLInputElement>document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.border = "none");
          }
         
       
	 		}
	 		else if (this.checlistData[curchecklistId].DataType == 'Decimal') {
         
         var value=((<HTMLInputElement>document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).value);
           var euipid=Number(value);
           
          
         if (((<HTMLInputElement>document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).value).length == 0 ||isNaN(euipid) )//|| !isNumeric($('#CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).val())) 
         {
	 				success = false;
	 				errorQuestionID += this.checlistData[curchecklistId].RowNum + '. ' + this.checlistData[curchecklistId].QuestionText + '.<br>';	
	 				document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).style.border = "1px solid red";
	 			}
	 			else {
 				//document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).value = parseFloat(document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID).value);
	 			((<HTMLInputElement>document.getElementById('CheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.border = "none");
	 			}
	 		}
	 		else if (this.checlistData[curchecklistId].DataType == 'Boolean' && this.checlistData[curchecklistId].Name == 'Y/N') {
        if(!((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).checked))
        
           {
	 			 	success = false;
	 			 	errorQuestionID += this.checlistData[curchecklistId].RowNum + '. ' + this.checlistData[curchecklistId].QuestionText + '.<br>';	
	 			 	((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "1px solid red");
            ((<HTMLInputElement>document.getElementById('NCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "1px solid red");
				 }
	 			 else {
          ((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "");				
          ((<HTMLInputElement>document.getElementById('NCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "");
	 			}
	 		}			
			else if (this.checlistData[curchecklistId].DataType == 'Boolean' && this.checlistData[curchecklistId].Name == 'Y/N/NA') {
         if (!((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).checked) && !((<HTMLInputElement>document.getElementById('NCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).checked) && !((<HTMLInputElement>document.getElementById('NACheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).checked))
          {
				 	success = false;
				 	errorQuestionID += this.checlistData[curchecklistId].RowNum + '. ' + this.checlistData[curchecklistId].QuestionText + '.<br>';	
				 	((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "1px solid red");
				 	((<HTMLInputElement>document.getElementById('NCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "1px solid red");
           ((<HTMLInputElement>document.getElementById('NACheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "1px solid red");
				}
			  else {
          ((<HTMLInputElement>document.getElementById('YCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "");				
					((<HTMLInputElement>document.getElementById('NCheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "");
          ((<HTMLInputElement>document.getElementById('NACheckListID' + this.checlistData[curchecklistId].QuestionID + "_" + this.checlistData[curchecklistId].EquipmentID)).style.outline = "");
				 }
			}			
		}
	}		
	

	  if (!success) {
	 	this.ErrorMessage='You must enter a response for each question:' +errorQuestionID +'<br/>';	
	 	this.ErrorDialoag=true;
	 }	

	return success;

 }

 createChecklist:any[];
 async createChecklistResponseParent(){
   let result=false
   
  for(let i=0;i<=this.selectedData.length;i++)
  { 
  let CREATECHECKLISTRESPONSEPARENT = {
		ScanEquipmentID:this.selectedData[0].EquipmentID,
    UserID:this.userDetail.userId,

  }
  this.createChecklist=null
   
  if(CREATECHECKLISTRESPONSEPARENT!=null)
  {
    this._ChecklistService.createChecklistResponseParentasync(JSON.stringify({CREATECHECKLISTRESPONSEPARENT}))
     .then((resp: Array<any>) => {
      this.createChecklist= resp;
     
      this.waterlogid=this.createChecklist[0].WaterLogID;
      result=true;
      this.createChecklistResponseSub();
     },(error) => 
     {
       this.serviceRequesttList = [];
       this.changeDetectorRef.detectChanges();
       // handle error here
       alert('error')
     });
    
  }
  return result
}

 }

 public createChecklistResponseSub(){
  for(let i=0;i<this.selectedData.length;i++)
  { 
  let CREATECHECKLISTRESPONSESUB = {
    
		WaterLogID:this.waterlogid,//this.serviceRequesttList[0].WaterLogID
   EquipmentID:this.selectedData[i].EquipmentID,
    QuestionID: 1,
    ResponseText :'Y'

  }
   

this.createChecklist=null
  if(CREATECHECKLISTRESPONSESUB!=null)
  {
    this._ChecklistService.createChecklistResponseSub(JSON.stringify({CREATECHECKLISTRESPONSESUB}))
     .subscribe((resp: Array<any>) => {
       
      this.createChecklist= resp;
     
         
     },
     (error) => 
     {
       this.serviceRequesttList = [];
       this.changeDetectorRef.detectChanges();
       // handle error here
     }
   
     );
  }

  }
 }

 public createTickt(requestId:number)
 {
    try
    {
     
       let createTicketFromServiceRequestParam=
       {
         "CREATETICKETFROMSERVICEREQUEST" : {
           ServiceRequestID: requestId,
           UserId: this.userDetail.userId,
         }
        }

      this._ticketService.createTicketFromServiceRequest(JSON.stringify(createTicketFromServiceRequestParam)).subscribe(data=>
       {
        this.showGlobalLoader=false;
         if(data!=null && data.length>0)
         {
          
           let ticketId = data[0].TicketID;
           //this.router.navigate(['/tickets/',{'&ticketId':ticketId}]);
           this.router.navigate(['/tickets', ticketId]);
         }
       },
       (error)=>
       {
          this.showGlobalLoader=false;
          console.log(error);
       }
       )

    }
    catch(ex)
    {
      this.showGlobalLoader=false;
      console.log(ex);
    }
 }

async CREATESERVICEREQUEST()
{
  
  this.selectedData
  
  let  EquipmentID:any;
  //let FacilityMasterID:any;
  var result=false;
   //FacilityMasterID=this.selectedData[EquipmentID].Fa
  for(var ecuip in this.selectedData)
  { 
      var arr = [];
      var result = false;

      
      let dashcreateservicerequestParam = { 
      RequestSourceID: 3,   
      UserID:this.userDetail.userId,
      FacilityMasterID:this.selectedData[ecuip].facilityMasterid,
      WorkTypeID:2,//default for service request.
      EquipmentID:this.selectedData[ecuip].EquipmentID,
      SQACodeID: this.selectedSQACode,
      RequestDescription: '',
      SQASubCodeID:null, 
      PMSequenceID:null,
      // serviceRequestTypeId: 1,
      // requestStatusId: 2,
      // requestType: 'sr',
     }
 
     var CREATESERVICEREQUEST = dashcreateservicerequestParam;
     this.serviceRequesttList = null;
 
     if (dashcreateservicerequestParam != null) {
       this.loading = true;
       await this.sRequest.createServiceRequestasync(JSON.stringify({CREATESERVICEREQUEST}))
       .then((resp: any) => {
         
           this.serviceRequesttList= resp;
            var sData:any;
            if(this.selectedActivity=='2' || this.selectedActivity=='3' )
            {
               for(var serviceRequesttList1 of this.serviceRequesttList )
             {
              this.selectedData[ecuip].ReferenceNo=this.serviceRequesttList[0].serviceRequestId;
             
             this.createddate=this.serviceRequesttList[0].DateCreated;
               result=true;
             }
            }
           
            else{
             this.selectedData[0].ReferenceNo=this.serviceRequesttList[0].serviceRequestId;
             this.createddate= this.serviceRequesttList[0].DateCreated;
             

             this.createddate=this.serviceRequesttList[0].DateCreated;
             result=true;
            }
           
          
         }, 
         (error) => 
         {
           this.serviceRequesttList = [];
           this.changeDetectorRef.detectChanges();
           // handle error here
         }
       );

     }
  //  return result

  }

  
}
 
/* Service Calls  Ends Here*/
}
